import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { Drawer as MuiDrawer, IconButton } from '@material-ui/core';
import { ArrowBack as BackIcon, Close as CloseIcon } from '@material-ui/icons';
import styled from 'styled-components';
import { Button } from "../button/Button.js";
import { DrawerActions } from "../drawer/DrawerActions.js";
import { DrawerContent } from "../drawer/DrawerContent.js";
import { DrawerTitle } from "../drawer/DrawerTitle.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var StyledActionsLayout = /*#__PURE__*/styled.div.withConfig({
  displayName: "AppDrawer__StyledActionsLayout",
  componentId: "SD__sc-1ivw8lf-0"
})(["display:flex;gap:16px;"]);
var sizeToMaxWidthMap = {
  md: '432px',
  lg: '600px',
  xl: '746px',
  xxl: '900px'
};
export function AppDrawer(_ref) {
  var {
    title,
    subtitle,
    children,
    open,
    onClose,
    onBack,
    primaryAction,
    secondaryAction,
    disableContentPadding = false,
    disableCloseButton = false,
    size = 'md'
  } = _ref;
  return /*#__PURE__*/_jsxs(MuiDrawer, {
    open: open,
    onClose: onClose,
    anchor: "right",
    PaperProps: {
      style: {
        width: '100%',
        maxWidth: sizeToMaxWidthMap[size]
      }
    },
    children: [/*#__PURE__*/_jsx(DrawerTitle, {
      title: title,
      subtitle: subtitle,
      startAction: onBack && /*#__PURE__*/_jsx(IconButton, {
        onClick: onBack,
        edge: "start",
        children: /*#__PURE__*/_jsx(BackIcon, {
          color: "action"
        })
      }),
      endAction: !disableCloseButton && /*#__PURE__*/_jsx(IconButton, {
        onClick: onClose,
        children: /*#__PURE__*/_jsx(CloseIcon, {
          color: "action"
        })
      })
    }), disableContentPadding ? children : /*#__PURE__*/_jsx(DrawerContent, {
      children: children
    }), (primaryAction || secondaryAction) && /*#__PURE__*/_jsx(DrawerActions, {
      children: /*#__PURE__*/_jsxs(StyledActionsLayout, {
        children: [primaryAction && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          type: "button",
          variant: "contained"
        }, primaryAction), {}, {
          children: primaryAction.label
        })), secondaryAction && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          type: "button",
          variant: "outlined"
        }, secondaryAction), {}, {
          children: secondaryAction.label
        }))]
      })
    })]
  });
}